import { AddIconData, HomeIconData } from "@meiden-connect/material-symbols";
import { Button, Icon } from "@meiden-connect/ui";
import { useEffect, useState } from "react";
import { generateCanvasId } from "../../../lib/canvas-id";
import { DEFAULT_CANVAS_TITLE, normalizeCanvasTitle } from "../../../lib/canvas-title";
import { navigate } from "../../../router";
import { useCanvasDocStore } from "../store/canvas-doc-store";
import { useCanvasOpDispatcherContext } from "../dispatcher-context";

interface Props {
  readonly canvasId: string;
}

// 左上のフローティングアプリメニュー。
// TOP / 新規ボタンに加えて、現在のキャンバス名をその場で編集できるようにする。
export function AppMenu({ canvasId: _canvasId }: Props): JSX.Element {
  const rawTitle = useCanvasDocStore((s) => s.meta.title);
  // 旧データ「未保存のキャンバス」も含めて表示時には常に正規化する。
  const title = normalizeCanvasTitle(rawTitle);
  const dispatcher = useCanvasOpDispatcherContext();
  const [draftTitle, setDraftTitle] = useState(title);

  useEffect(() => {
    setDraftTitle(title);
  }, [title]);

  const commitTitle = (): void => {
    const trimmed = draftTitle.trim();
    const next = trimmed.length > 0 ? trimmed : DEFAULT_CANVAS_TITLE;
    setDraftTitle(next);
    if (next !== rawTitle) {
      dispatcher.updateCanvasMeta({ title: next });
    }
  };

  return (
    <div className="canvas-app-menu">
      <Button
        type="button"
        variant="action"
        onClick={() => navigate("/")}
        aria-label="ダッシュボードへ戻る"
        title="ダッシュボードへ戻る"
      >
        <Icon d={HomeIconData} />
      </Button>
      <Button
        type="button"
        variant="action"
        // 新規キャンバスは現在のキャンバスと比較・参照しながら使えるよう別ウィンドウで開く。
        onClick={() => window.open(`/c/${generateCanvasId()}`, "_blank", "noopener,noreferrer")}
        aria-label="新規キャンバスを別ウィンドウで作成"
        title="新規キャンバスを別ウィンドウで作成"
      >
        <Icon d={AddIconData} />
      </Button>
      <label className="canvas-title-editor">
        <span>キャンバス名</span>
        <input
          aria-label="キャンバス名"
          value={draftTitle}
          onChange={(event) => setDraftTitle(event.currentTarget.value)}
          onBlur={commitTitle}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.currentTarget.blur();
            }
          }}
        />
      </label>
    </div>
  );
}
